module.exports = __webpack_public_path__ + "static/hands-a9a395bd7f8196e5421ceada523c1765.jpg";